import React, { PureComponent } from 'react';
import Header from '../Header';
import Footer from '../Footer';

class Layout extends PureComponent {
  render() {
    const { children } = this.props;
    const { points } = this.props;

    return (
      <div id="outter">
        <div id="master-wrapper">
          <Header points={points} />
          {children}
        </div>
        <Footer />
      </div>
    );
  }
}

export default Layout;
